<template>
  <div
    class="relative bg-white"
    :class="arClass"
    data-test-id="component-video-player"
  >
    <video
      ref="employeeVideoRef"
      :autoplay="autoplay"
      class="w-full p-0 m-0 absolute inset-0 z-10"
      :poster="poster"
    >
      <source :src="src" :type="type">
    </video>
    <button
      class="play-pause-button focus:outline-none z-10"
      data-test-id="button-video-player-play-pause"
      aria-label="Play or Pause Video"
      @click="playPauseVideo"
    >
      <div v-if="!loading" :class="{ 'playing' : playing }" class="btn-play" />
      <div v-else class="loader">
        <div class="spinner text-white" />
      </div>
    </button>
    <MajorityUiMajorityImage :src="poster" alt="poster" class="w-full absolute inset-0" />
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: () => 'video/mp4'
    },
    poster: {
      type: String,
      default: () => ''
    },
    autoplay: {
      type: Boolean,
      default: () => false
    },
    arClass: {
      type: String,
      default: 'ar-16by9'
    }
  },
  data () {
    return {
      playing: false,
      loading: true
    }
  },
  computed: {
    isPlaying () {
      return this.playing
    }
  },
  mounted () {
    this.$refs.employeeVideoRef.addEventListener('loadeddata', () => {
      this.loading = false
    })
    this.$refs.employeeVideoRef.addEventListener('play', () => {
      this.playing = true
    })
    this.$refs.employeeVideoRef.addEventListener('pause', () => {
      this.playing = false
    })
    this.$refs.employeeVideoRef.addEventListener('ended', () => {
      this.playing = false
      this.$refs.employeeVideoRef.currentTime = 0
    })
  },
  methods: {
    playPauseVideo () {
      this.$refs.employeeVideoRef.paused ? this.play() : this.pause()
    },
    play () {
      this.$refs.employeeVideoRef.play()
    },
    pause () {
      this.$refs.employeeVideoRef.pause()
    }
  }
}
</script>

<style lang="postcss" scoped>
.play-pause-button {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  .btn-play {
    transition: opacity .35s ease;
    margin-left: 2px;
    border-color: transparent transparent transparent #ffffff;

    /* play state */
    border-style: solid;
    border-width: 35px 0 35px 60px;
    opacity: .7;

    &.playing {
      opacity: 0;
    }
  }

  &:hover {
    .btn-play {
      border-color: transparent transparent transparent #f0f0f0;
    }
  }
}
.spinner {
  width: 40px;
  height: 40px;

  position: relative;
  margin: 100px auto;
}

.double-bounce1, .double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #333;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bounce {
  0%, 100% { transform: scale(0.0); -webkit-transform: scale(0.0); }
  50% { transform: scale(1.0); -webkit-transform: scale(1.0); }
}
</style>
